import { render, staticRenderFns } from "./page-create-reward.vue?vue&type=template&id=17ec91ec&"
import script from "./page-create-reward.vue?vue&type=script&lang=ts&"
export * from "./page-create-reward.vue?vue&type=script&lang=ts&"
import style0 from "./page-create-reward.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports